function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
  fill: "#5C0BD9"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.8 17.6001L14 28.4001V25.5001L21.9 17.6001H24.8Z",
  fill: "#AA9371"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M32.4 17.6001L14 36.0001V33.2001L29.6 17.6001H32.4Z",
  fill: "#AA9371"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.1 40.5C21.8 41.5 21.6 42.5 21.6 43.5V43.8L19 46.4H16.2L22.1 40.5Z",
  fill: "#AA9371"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.7 31.9999L14 43.6999V40.8999L25 29.8999C25.1 30.6999 25.4 31.3999 25.7 31.9999Z",
  fill: "#AA9371"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.1 17.6L35.1 22.6C34.4 22.3 33.7 22 32.9 21.9L37.3 17.5H40.1V17.6Z",
  fill: "#AA9371"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M47.8 17.6001L38.6 26.8001C38.4 26.1001 38.1 25.5001 37.7 24.9001L45 17.6001H47.8Z",
  fill: "#AA9371"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M50 20.3V23.1L37.9 35.2001C37.4 34.9001 36.9 34.6 36.4 34.3C37.2 33.7 37.8 32.9 38.2 32.1L50 20.3Z",
  fill: "#AA9371"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.4 37.6L50 28V30.8L41.5 39.3C41.2 38.7 40.8 38.1 40.4 37.6Z",
  fill: "#AA9371"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M32 32.8999C34.2091 32.8999 36 31.109 36 28.8999C36 26.6908 34.2091 24.8999 32 24.8999C29.7909 24.8999 28 26.6908 28 28.8999C28 31.109 29.7909 32.8999 32 32.8999Z",
  stroke: "white",
  strokeWidth: 1.7439,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40 44C40 39.7 36.4 36.2 32 36.2C27.6 36.2 24 39.7 24 44V45.4C24 45.9 24.3 46.2 24.8 46.2H39.1C39.6 46.2 39.9 45.9 39.9 45.4V44H40Z",
  stroke: "white",
  strokeWidth: 1.7439,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.1 40.5C21.8 41.5 21.6 42.5 21.6 43.5V43.8L19 46.4H16.2L22.1 40.5Z",
  fill: "white"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M47.8 17.6001L38.6 26.8001C38.4 26.1001 38.1 25.5001 37.7 24.9001L45 17.6001H47.8Z",
  fill: "white"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M50 20.3V23.1L37.9 35.2001C37.4 34.9001 36.9 34.6 36.4 34.3C37.2 33.7 37.8 32.9 38.2 32.1L50 20.3Z",
  fill: "white"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M50 28V30.8L41.5 39.3C41.2 38.7 40.8 38.1 40.4 37.5L50 28Z",
  fill: "white"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M50 35.6001V38.4001L42.4 46.0001V43.5001C42.4 43.4001 42.4 43.3001 42.4 43.2001L50 35.6001Z",
  fill: "white"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.7 31.9999L14 43.6999V40.8999L25 29.8999C25.1 30.6999 25.4 31.3999 25.7 31.9999Z",
  fill: "white"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.1 17.6L35.1 22.6C34.4 22.3 33.7 22 32.9 21.9L37.3 17.5H40.1V17.6Z",
  fill: "white"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M32.4 17.6001L14 36.0001V33.2001L29.6 17.6001H32.4Z",
  fill: "white"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.8 17.6001L14 28.4001V25.5001L21.9 17.6001H24.8Z",
  fill: "white"
});

var SvgBgIcon = function SvgBgIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBgIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bg-icon.e866c03f.svg";
export { ForwardRef as ReactComponent };